<div class="flex flex-col">
  <div *ngIf="sectionFormControl.value?.length">
    <ng-container *ngFor="let media of sectionFormControl.value; let i = index">
      <div class="flex flex-col justify-center w-full my-4 space-y-2 shrink-0">
        <button
          *ngIf="!isMainMedia && !isSlide"
          type="button"
          class="flex items-center justify-center w-full px-2 py-2 mb-1 space-x-1 text-xs font-semibold border text-project-4400 border-project-4500 bg-project-4600 hover:brightness-110 hover:cursor-pointer"
          (click)="handleInsertMedia.emit(media)"
          data-testid="media-adder-item-insert-btn"
        >
          <i class="text-inherit icon icon-arrow-circle-up"></i>
          <span>Insert into body</span>
        </button>
        <div class="flex items-center w-full">
          <ng-container
            *ngTemplateOutlet="
              templateOutlet;
              context: { $implicit: media, index: i }
            "
          ></ng-container>
          <ng-content></ng-content>
        </div>
        <div class="flex space-x-4" *ngIf="!isDisabled">
          <button
            type="button"
            class="flex items-center self-start pb-1 space-x-2 text-xs text-project-100 hover:text-project-2100 hover:cursor-pointer"
            (click)="
              handleRemoveMedia.emit({
                mediaToRemove: media,
                mediaIndexToRemove: i
              })
            "
            data-testid="media-adder-item-remove-btn"
          >
            <i class="text-inherit icon icon-remove"></i>
            <span>Remove</span>
          </button>
          <button
            *ngIf="isMainMedia || isSlide"
            type="button"
            class="flex items-center self-start pb-1 space-x-2 text-xs text-project-100 hover:text-project-2100 hover:cursor-pointer"
            (click)="handleAddMedia.emit(mediaType)"
            data-testid="media-adder-item-replace-btn"
          >
            <i class="text-inherit icon icon-exchange"></i>
            <span>Replace</span>
          </button>
        </div>
      </div>
    </ng-container>
  </div>
  <div
    class="py-2 space-x-3 hover:cursor-default empty:py-0 hover:text-project-2100 text-project-2400"
    *ngIf="!isDisabled"
  >
    <button
      *ngIf="
        ((isSlide && !sectionFormControl.value?.length) || !isSlide) &&
        ((isMainMedia && !sectionFormControl.value?.length) || !isMainMedia)
      "
      type="button"
      class="flex items-center space-x-2"
      (click)="handleAddMedia.emit(mediaType)"
      data-testid="media-adder-item-add-btn"
    >
      <i [ngClass]="cssIconClass" class="text-inherit icon"></i>
      <span class="text-sm text-inherit"
        >{{ addMediaLabel }}
        {{ mediaType === MEDIA_TYPES.IMAGE ? "image" : "video" }}</span
      >
    </button>
  </div>
</div>
